module.exports = __webpack_public_path__ + "static/media/two.aadb6c47.svg";